import md5 from 'md5';

export const API_KEY = 'OIuVdYV3qgkrfwS3vpYyyChBTICfJH7NL1SIvFh0';
export const API_URL = 'https://api.rp.ourcart.com/v11';
export const API_S3_URL = 'https://vc1aahw5oi.execute-api.us-east-1.amazonaws.com/Staging/v1';
export const CLIENT_CODE = 'DM';
export const clientUserId = md5('' + Math.random());

export const FILE_TYPES = [
  'jpg',
  'jpeg',
  'png',
//  'gif',
//  'pdf',
];
export const MIME_TYPES = [
//  'application/pdf',
  ...FILE_TYPES.map((type) => `image/${type.toLowerCase()}`)
];
